<template>
  <nav class="main-nav" v-if="navVisible">
    <a
      href="#"
      :class="['nav-link', getActiveCSSClass(currentView, pageViews.COMPONENTVIEW)]"
      @click.prevent="selectTab(pageViews.COMPONENTVIEW)"
    >
      Use Cases
    </a>

    <a
      href="#"
      :class="['nav-link', getActiveCSSClass(currentView, pageViews.PROCESS_DETAILS_VIEW)]"
      @click.prevent="selectTab(pageViews.PROCESS_DETAILS_VIEW)"
    >
      Processes
    </a>

    <a
      href="#"
      :class="['nav-link', getActiveCSSClass(currentView, pageViews.TRANSITIONVIEW)]"
      @click.prevent="selectTab(pageViews.TRANSITIONVIEW)"
    >
      Transitions
    </a>

    <a
      href="#"
      :class="['nav-link', getActiveCSSClass(currentView, pageViews.FIELDMAPPINGVIEW)]"
      @click.prevent="selectTab(pageViews.FIELDMAPPINGVIEW)"
    >
      Field Mappings
    </a>

    <a
      href="#"
      :class="['nav-link', getActiveCSSClass(currentView, pageViews.MAPPING_REFERENCES_VIEW)]"
      @click.prevent="selectTab(pageViews.MAPPING_REFERENCES_VIEW)"
    >
      Mapping References
    </a>

    <a
      href="#"
      :class="['nav-link', getActiveCSSClass(currentView, pageViews.MAPPING_JOBS_VIEW)]"
      @click.prevent="selectTab(pageViews.MAPPING_JOBS_VIEW)"
    >
      Mapping Jobs
    </a>
  </nav>
</template>


<script>
import { pageViews } from "../../utils/util";

export default {
    name: pageViews.TAB_CONTENT_VIEW,
    data() {
        return {
            // currentView: pageViews.USAGEVIEW,
            currentView: pageViews.COMPONENTVIEW, // Default to Activities tab
            pageViews: Object.freeze(pageViews),
            navVisible: true,
        };
    },
    methods: {
        selectTab(view) {
            this.currentView = view;
            this.$emit('tab-selected', view);
        },
        getActiveCSSClass(currentView, view) {
            return currentView === view ? 'link router-link-active' : 'link';
        },
        toggleNav() {
            this.navVisible = !this.navVisible;
        }
    }
};
</script>

<style scoped>
.main-nav {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  background-color: var(--surface);
  border-bottom: 1px solid var(--border-color);
  padding: 0.5rem 1.5rem;
  box-shadow: 0 2px 5px var(--shadow-soft);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.nav-link {
  position: relative;
  text-decoration: none;
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--text-secondary);
  padding: 0.5rem 0;
  transition: color 0.2s ease, border-color 0.2s ease;
}

.nav-link:hover {
  color: var(--primary);
}

/* Active state — subtle underline + color */
/* Active highlight */
.nav-link.router-link-active {
  color: var(--primary);
  font-weight: 600;
  position: relative;
}

/* Underline for active tab */
.nav-link.router-link-active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -3px;
  width: 100%;
  height: 2px;
  background-color: var(--primary);
  border-radius: 2px;
}


.nav-link.active::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: -3px;
  width: 100%;
  height: 2px;
  background-color: var(--primary);
  color:#fff;
  border-radius: 1px;
  transition: width 0.3s ease;
}



</style>